










































































































































































import Vue from "vue";
import GrayDivider from "../components/HomePage/GrayDivider.vue";
// import GoogleMap from "../components/HomePage/GoogleMap.vue";
// import ImageCarousel from "../components/HomePage/ImageCarousel.vue";
import QuickLinks from "../components/HomePage/QuickLinks.vue";
import YoutubeVideo from "../components/HomePage/YoutubeVideo.vue";
import SubscribeButton from "../components/HomePage/SubscribeButton.vue";
import TwitterFeed from "../components/HomePage/TwitterFeed.vue";
import HomeSVG from "../assets/i10homepage.svg";

export default Vue.extend({
  name: "HomePage",
  components: {
    GrayDivider,
    // GoogleMap,
    // ImageCarousel,
    QuickLinks,
    YoutubeVideo,
    SubscribeButton,
    TwitterFeed,
    HomeSVG
  },
  data: () => ({
    viewBtns: {
      viewProjLimBtn: true,
      viewAlt5GBtn: true,
      viewAlt3EBtn: true,
      viewAlt3ABtn: true
    },
    mapLayers: {
      projectLimits: true,
      alt5GLayer: false,
      alt3ELayer: false,
      alt3ALayer: false
    }
  }),
  methods: {
    toggle(layers: object) {
      this.mapLayers = { ...this.mapLayers, ...layers };
    },
    openExternalLink(url: string) {
      window.open(url, "_blank");
    }
  }
});
